export default {
  value: {
    type: [String, Object, Array],
    default: null,
  },
  store: {
    type: Object,
    default: null,
  },
  autoComplete: {
    type: Boolean,
    default: false,
  },
  // 是否禁用 Poptip
  disabledPoptip: {
    type: Boolean,
    default: false,
  },
  //input 是否允许禁止
  disabled: {
    type: Boolean,
    default: false,
  },
  //输入框的提示信息
  placeholderInput: {
    type: String,
    default: '',
  },
  //输入框的宽度
  inputWidth: {
    type: [String, Number],
    default: 160,
  },
  // 提交给后台的数据是否为obj
  valueIsObject: {
    type: Boolean,
    default: true,
  },
  // 提交给后台的值  有这个的原因是 输入框显示的内容可能是传递给后台的不一样
  valueKey: {
    type: String,
    default: 'code',
  },
  //在名称前面显示数据  暂时不用
  // showCodeKey: {
  //   type: String,
  //   default: null,
  // },
  //输入框的值
  inputKey: {
    type: String,
    default: 'name',
  },
  //清除显示
  clearShowValue: {
    type: Boolean,
    default: false,
  },
  //表格的高度
  tableHeight: {
    type: [String, Number],
    default: 266,
  },
  //表格的最大高度
  maxHeight: {
    type: [String, Number],
  },

  //分页数据
  pageNo: {
    type: Number,
    default: 1,
  },
  //每页展示的数据
  pageSize: {
    type: Number,
    default: 999,
  },
  //是否显示底部分页
  shwoPage: {
    type: Boolean,
    default: false,
  },
  //列表定义配置获取URL
  tableColumnDefUrl: {
    type: String,
    default: null,
  },
  //表格数据
  columnData: {
    type: [String, Object, Array],
    default: null,
  },

  //获取数据的请求方法
  getTableDataMethod: {
    type: String,
    default: 'post',
  },
  //获取表格数据的接口
  getTableDataUrl: {
    type: String,
    default: '',
  },
  //获取表格数据的参数
  getTableDataParams: {
    type: Object,
    default: () => ({}),
  },
  //vxeTable 键盘参数
  keyboardConfig: {
    type: Object,
    default() {
      return { isArrow: true }
    },
  },
  //弹出框参数
  //分类
  typeList: {
    type: Array,
    default: () => [
      {
        name: '自定义分类',
        code: 'CUSTOM_CATALOG_ONE',
      },
      {
        name: '自定义分类2',
        code: 'CUSTOM_CATALOG_TWO',
      },
      {
        name: '自定义分类3',
        code: 'CUSTOM_CATALOG_THREE',
      },
    ],
  },
  //默认选中的分类
  propsType: {
    type: Object,
    default: () => ({
      name: '自定义分类',
      code: 'CUSTOM_CATALOG_ONE',
    }),
  },
  //分类请求的接口
  treeUrl: {
    type: String,
    default: '',
  },
  //请求方法
  treeMethod: {
    type: String,
    default: 'get',
  },
  treeParams: {
    type: Object,
    default: () => ({}),
  },
  //弹出的表格的定义
  modalTableColumnDefUrl: {
    type: String,
    default: '', // ~static/rest/main/dict/getTableByCode?tableCode=
  },
  showAllExpandBtn: {
    // 是否显示  全部展开按钮
    type: Boolean,
    default: true,
  },
  // 查询表单表单定义配置Url
  searchUrlItemsDef: {
    type: String,
    default: '',
  },

  //表格请求数据
  tableDataUrlQuery: {
    type: String,
    require: true,
    default: '',
  },
  // 表格查询-参数
  tableDataUrlQueryParamter: {
    type: Object,
    default: () => ({}),
  },
  // 查询table请求方式
  tableDataUrlQueryMethod: {
    type: String,
    default: 'get',
  },
  //表格是否显示多选
  selection: {
    type: Boolean,
    default: false,
  },
  //是否显示多选按钮组
  isShowFooterBtn: {
    type: Boolean,
    default: false,
  },
  //是否显示表格行级操作
  menuShow: {
    type: Boolean,
    default: true,
  },
  // #7962 清空的时候需要做一个交互，之前没有抛出过，为了不影响之前使用data的地方，再这里加个参数
  needOnClearRes: {
    type: Boolean,
    default: false,
  },
}
